<template>
    <div class="col-lg-4 m-auto">
        <card :title="$t('edit_company')">
            
            <form @submit.prevent="saveCompany"
                @keydown="form.onKeydown($event)">
                <!-- Name -->
                <div class="form-group">
                    <label>{{ $t('name') }}</label>
                    <input v-model="form.name"
                        :class="{ 'is-invalid': form.errors.has('name') }"
                        class="form-control"
                        type="text"
                        name="name">
                    <has-error :form="form"
                        field="name" />
                    
                    <label class="mt-2">{{ $t('contact_email') }}</label>
                    <input v-model="form.email"
                        :class="{ 'is-invalid': form.errors.has('email') }"
                        class="form-control"
                        type="text"
                        name="email">
                    <has-error :form="form"
                        field="email" />
                </div>

                
            </form>
            <div slot="footer" class="text-right">
                <button class="btn btn-primary" :loading="form.busy" @click="saveCompany">
                    {{ $t('save') }}
                </button>
            </div>
        </card>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Form from "vform";
import Modal from "~/components/Modal";

export default {
    data() {
        return {
            loading: false,
            companies: null,
            editCompany : null,
            error: null,
            form: new Form({
                name: "",
                email: ""
            })
        };
    },
    components: {
        Modal
    },
    created() {
        if(this.id) this.fetchData(this.id);
    },
    computed: {
        id(){
            return this.$route.params.id ? this.$route.params.id : false;
        }
    },
    methods: {
        async fetchData(id) {
            this.loading = true;

            const { data } = await axios.get("/api/company/" + id);
            
            this.loading = false;
            this.form.name = data.name;
        },
        async deleteCompany(id) {
            if(confirm(this.$t('delete_company'))){
                const { data } = await this.form.delete("/api/company/" + id);
                this.fetchData();
            }
        },
        async saveCompany() {
            // Register the company.
            if(this.id){
                const { data } = await this.form.patch("/api/company/" + this.id);
            } else {
                const { data } = await this.form.post("/api/company");
            }
            
            this.$router.push({ name: 'admin.companies' });

        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/companies/form.vue